export default __webpack_public_path__ + "static/ctm360-986357e35345c313fee5782d09431479.png";